import { createElement, setText } from './dom';
import { setLabel } from './i18n';
import { createIcon } from './icons';
import type { CitizenSelection } from './citizenSelection';

export function createCitizenRegister(parent: HTMLElement, selection: CitizenSelection) {
  const register = createElement('div', 'citizen-register', parent);
  setText(createElement('span', 'register-label', register), 'City register');
  const line = createElement('div', 'register-line', register);
  const name = createElement('button', 'register-name', line);
  name.type = 'button';
  name.id = 'citizen-name';
  name.setAttribute('aria-haspopup', 'dialog');
  setLabel(name, 'aria-label', 'Choose a name from the city register');
  const dice = createElement('button', 'register-dice', line);
  dice.type = 'button';
  setLabel(dice, 'aria-label', 'Choose another name');
  const icon = createIcon('dice', 16);
  icon.setAttribute('aria-hidden', 'true');
  dice.append(icon);
  const { dialog, entries } = createRegisterDialog(parent);

  function update(): void {
    setText(name, selection.name);
    entries.replaceChildren();
    for (const value of selection.names) {
      const entry = createElement('button', 'register-entry', entries);
      entry.type = 'button';
      setText(entry, value);
      entry.setAttribute('aria-pressed', String(value === selection.name));
      entry.addEventListener('click', () => {
        selection.chooseName(value);
        update();
        dialog.close();
      });
    }
  }
  name.addEventListener('click', () => {
    dialog.showModal();
    entries.querySelector<HTMLButtonElement>('[aria-pressed="true"]')?.focus();
  });
  dice.addEventListener('click', () => {
    selection.rollName();
    update();
  });
  update();
  return {
    update,
    dispose: () => {
      dialog.remove();
    },
  };
}

function createRegisterDialog(parent: HTMLElement) {
  const dialog = createElement('dialog', 'register-dialog', parent);
  dialog.setAttribute('aria-labelledby', 'register-heading');
  const heading = createElement('h2', '', dialog);
  setText(heading, 'City register');
  heading.id = 'register-heading';
  const close = createElement('button', 'register-close', dialog);
  close.type = 'button';
  setLabel(close, 'aria-label', 'Close');
  const closeIcon = createIcon('close', 20);
  closeIcon.setAttribute('aria-hidden', 'true');
  close.append(closeIcon);
  close.addEventListener('click', () => {
    dialog.close();
  });
  const entries = createElement('div', 'register-entries', dialog);
  dialog.addEventListener('click', (event) => {
    if (event.target !== dialog) return;
    const box = dialog.getBoundingClientRect();
    if (
      event.clientX < box.left ||
      event.clientX > box.right ||
      event.clientY < box.top ||
      event.clientY > box.bottom
    )
      dialog.close();
  });
  return { dialog, entries };
}
